var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC9l\\xE9ments",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icones/Avatar/Fill/Noir",
    className: "st0-fill",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,5 C10.346,5 9,6.346 9,8 C9,9.654 10.346,11 12,11 C13.654,11 15,9.654 15,8 C15,6.346 13.654,5 12,5 M12,13 C9.243,13 7,10.757 7,8 C7,5.243 9.243,3 12,3 C14.757,3 17,5.243 17,8 C17,10.757 14.757,13 12,13",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0678696,21 C19.7461681,21 19.4328589,20.821 19.2603523,20.501 C17.7600114,17.725 14.9784594,16 12.0001568,16 C9.0209216,16 6.23936966,17.725 4.73996118,20.501 C4.48073508,20.979 3.90819975,21.142 3.46527747,20.865 C3.01955778,20.588 2.8675655,19.977 3.12585913,19.499 C4.95722621,16.107 8.35700441,14 12.0001568,14 C15.6423766,14 19.0421548,16.107 20.8735219,19.499 C21.132748,19.977 20.9807557,20.588 20.5341036,20.865 C20.3877061,20.957 20.2263891,21 20.0678696,21",
    id: "Fill-3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.dee28a5597aa34fea22b7f12459ab5c9.svg";
export { ForwardRef as ReactComponent };